// extracted by css-extract-rspack-plugin
export default {"searchInput":"bzY956","searchDropdown":"O3iBNj","result":"H7o7kq","noAfter":"NkxjgA"};